import React from 'react';
import NewDevice from 'Img/newdevice.svg';
import { Link } from 'react-router-dom';

const withContextPath = (path) => `${process.env.CONTEXT_PATH}/${path}`;

class DevicesTools extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  onNuovoUtente() {
    this.props.setUserToEdit(null);

    let config = require('../../../../config/config.json');
    const context = `/${config.context}`
    location.href = context + "/nuovo_ospite";
  }

  renderFilter(label, value) {
    const isActive = this.props.activeFilter === value;
    const counts = this.props.filterCounts || {};
    const count = counts[value];

    return (
      <button
        type="button"
        className={"devices-filter-chip " + (isActive ? "active" : "")}
        onClick={() => this.props.setActiveFilter(value)}>
        <span>{label}</span>
        {typeof count !== 'undefined' ? <small>{count}</small> : null}
      </button>
    );
  }

  render() {
    return (
      <div className="devices-tools-panel">
        <div id="devices-tools-btns">
          <Link id="devices-tools_newBtn" to={withContextPath("nuovo_dispositivo")}>{this.props.getLocale().GUESTS_NEW} <img src={NewDevice} /></Link>
        </div>
        <div className="devices-search-shell">
          <input id="devices-tools" type="text" placeholder={this.props.getLocale().DEVICES_TOOLS_SEARCH} onChange={(e) => this.props.setSearchedDeviceName(e.currentTarget.value)} />
        </div>
        <div className="devices-filter-bar" aria-label="Filtri dispositivi">
          {this.renderFilter('Tutti', 'all')}
          {this.renderFilter('Online', 'online')}
          {this.renderFilter('Offline', 'offline')}
          {this.renderFilter('Miei', 'mine')}
          {this.renderFilter('Ricevuti', 'shared')}
        </div>
      </div>
    )
  }
}

export default DevicesTools
export { DevicesTools }
